import { GET_USERS, GET_USER, LOADING_USER } from "../actions/types";

const initialState = {
  users: [],
  user: {},
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case GET_USER:
      return {
        ...state,
        user: action.payload,
      };
    case LOADING_USER:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};
